// composables/useInViewport.ts
import { onMounted, onUnmounted, ref } from 'vue'

interface UseInViewportOptions {
    threshold?: number
    rootMargin?: string
    onEnter?: () => void
    onLeave?: () => void
}

export function useInViewport(options: UseInViewportOptions = {}) {
    const { threshold = 0.1, rootMargin = '0px', onEnter, onLeave } = options

    const elementRef = ref<HTMLElement | null>(null)
    const isInViewport = ref(false)

    let observer: IntersectionObserver | null = null

    onMounted(() => {
        observer = new IntersectionObserver(
                ([entry]) => {
                    const entering = entry.isIntersecting

                    if (entering && !isInViewport.value) onEnter?.()
                    if (!entering && isInViewport.value) onLeave?.()

                    isInViewport.value = entering
                },
                { threshold, rootMargin }
        )

        if (elementRef.value) observer.observe(elementRef.value)
    })

    onUnmounted(() => observer?.disconnect())

    return { elementRef, isInViewport }
}